import React from 'react';
import { withIntl, IntlProps } from 'ha/i18n';
import { ShowAlert, AlertType } from 'ha/modules/Alertbar/types';
import HttpStatus from 'ha/constants/HttpStatus';

interface Props extends IntlProps {
  location: {
    query: {
      state: string;
      code: string;
    };
  };
  onSendAlert: (alert: ShowAlert) => void;
  onChangeLocation: (url: string) => void;
  requestGoogleLogin: (code: string) => Promise<number>;
}

const kind = AlertType.Danger;
const persistent = true;
const dismissAfter = 5000;

class GoogleLogin extends React.PureComponent<Props> {
  componentDidMount() {
    const {
      onSendAlert,
      onChangeLocation,
      requestGoogleLogin,
      location: {
        query: { code, state },
      },
      intl: { T, urlResolver },
    } = this.props;

    requestGoogleLogin(code).then((statusCode: number) => {
      if (
        statusCode === HttpStatus.BAD_REQUEST ||
        statusCode === HttpStatus.NOT_FOUND
      ) {
        const text =
          {
            [HttpStatus.BAD_REQUEST]: T(
              'We could not connect to your Google account',
            ),
            [HttpStatus.NOT_FOUND]: T(
              'Data was not found and we could not connect to your Google account',
            ),
          }[statusCode] || T('Something went wrong');

        onSendAlert({ text, kind, persistent, dismissAfter });
      }

      if (state) {
        const redirectUrl = urlResolver.getRedirectUrl(state);

        onChangeLocation(redirectUrl);

        return;
      }

      onChangeLocation(urlResolver.getBaseUrl());
    });
  }

  render() {
    return null;
  }
}

export default withIntl(GoogleLogin);
